import { render, staticRenderFns } from "./RateCardHome.vue?vue&type=template&id=b25dccb4&"
import script from "./RateCardHome.vue?vue&type=script&lang=ts&"
export * from "./RateCardHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports